import React from "react";
import {useSelector} from "react-redux";
import styled from "styled-components";
import UserCardNoInteraction from "../../user/UserCardNoInteraction";
import {v4 as uuidv4} from "uuid";

const Members = () => {
    const {pilot, copilot, members} = useSelector((state) => state.project);

    const displayMembersIfExists = () => {
        if (members.length === 0) {
            return <p className={"fw-700"}> Pas de membre pour ce projet </p>
        } else {
            const maxUsers = 10
            const displayedUser = members.slice(0, maxUsers)
            return (
                <>
                    {displayedUser.map(m => (
                        <UserCardNoInteraction
                            key={uuidv4()}
                            user={m}
                        />
                    ))}
                    {members.length > 10 ?
                        <NumberLeft>
                            <p> +{members.length - displayedUser.length} </p>
                        </NumberLeft>
                        :
                        ""
                    }
                </>
            )
        }
    }

    return (
        <Container className={"flex-col"}>
            <PilotCopilotContainer>
                <Pilot className={"flex-col gap-05"}>
                    <div className={"flex-row ai-center jtc-center gap-05"}>
                        <h2> Pilote </h2>
                    </div>
                    <UserCardNoInteraction
                        user={pilot}
                    />
                </Pilot>
                {copilot &&
                <Copilot className={"copilot-container flex-col gap-05"}>
                    <div className={"flex-row ai-center jtc-center gap-05  "}>
                        <h2> Copilote </h2>
                    </div>
                    <UserCardNoInteraction
                        user={copilot}
                    />
                </Copilot>
                }
            </PilotCopilotContainer>

            <Teams>
                <div className={"flex-row  ai-center jtc-center gap-05"}>
                    <h2> Membres </h2>
                </div>
                <div className="wrapper">
                    <div className={"sub-wrapper"}>
                        {displayMembersIfExists()}
                    </div>
                </div>
            </Teams>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  grid-column-start: 2;
  grid-column-end: 12;
  grid-row-start: 4;
  grid-row-end: 7;
  gap: 1em;
  background-color: var(--color-white);
  border-radius: 15px;
  padding: 1rem;
  align-items: center;
  h2 {
    line-height: 2em;
  }
`
const PilotCopilotContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
`
const Pilot = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 1;
`

const Copilot = styled.div`
  grid-column-start: 3;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 1;
`
const Teams = styled.div`
  width: 100%;
  grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 2;
  flex-grow: 1;
  
  .wrapper {
    margin-top: 1em;
    display: inherit;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 1em;
    width: 100%;
    overflow-y: auto;

    .sub-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1em;

    }
  }
`

const NumberLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-purple);
  width: 3rem;
  height: 3rem;
  border-radius: 50%;

  p {
    color: var(--color-white);
    font-weight: 700;
  }
`
export default Members;